import type { Account } from '@interfaces/account';

import { Icon } from '@ovComponents/1-primative/icon/icon';
import { Card, CardContent } from '@ovComponents/2-component/card/card';
import { Box, IconButton, Typography } from 'hephaestus/web';
import { CloseRounded as CloseRoundedIcon } from 'hephaestus/webIcons';
import { useTranslation } from 'react-i18next';
import { GoalLinkingReview } from '../goalLinking';

type AccountReviewItemProps = {
  account: Account;
  onDeleteAccount: (account?: Account) => void;
};

export const AccountReviewItem = ({
  account,
  onDeleteAccount,
}: AccountReviewItemProps) => {
  const { t } = useTranslation(['accountTypes']);
  return (
    <Card variant='outlined' sx={{ mb: 2 }}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pl: 0.9,
          }}
        >
          <Typography variant='bodyLarge' sx={{ fontWeight: 600 }}>
            {t(`accountTypes:${account.type}`)}
          </Typography>
          {account.id ? undefined : (
            <IconButton aria-label='close' onClick={() => onDeleteAccount()}>
              <Icon icon={CloseRoundedIcon} size='small' />
            </IconButton>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mt: 1,
            px: 1,
          }}
        >
          <GoalLinkingReview account={account} />
        </Box>
      </CardContent>
    </Card>
  );
};

export const getAcccountDetailComponent = ({
  field,
  value,
}: {
  field: string;
  value: string;
}): JSX.Element => (
  <>
    <Typography variant='labelLarge' sx={{ fontWeight: 600 }}>
      {field}
    </Typography>
    <Typography variant='bodyMedium' sx={{ fontWeight: 500 }}>
      {value}
    </Typography>
  </>
);

export default AccountReviewItem;
